import React from 'react';
import { Field } from 'react-final-form';

import fieldRequired from '../../../validators/fieldRequired';
import Input from '../../Input';
import { H5 } from '../../Typography';

import styles from '../UploadDocumentModal.module.scss';

const DocumentTitleStep = () => {
  return (
    <div className={styles.uploadedState}>
      <div className={styles.documentTitle}>
        <H5>Document title</H5>
        <Field
          component={Input}
          id="name"
          name="name"
          className={styles.input}
          validate={fieldRequired}
          maxLength={200}
          help={(val = '') => `${val.length} / 200 characters used`}
        />
      </div>
    </div>
  );
};

export default DocumentTitleStep;
